<template>
    <div class="editor" :class="{'disabled':data.disabled}">
        <textarea
            :id="inputFieldId"
            :name="name"
            v-html="fieldValue"
        />
    </div>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import {axiosPost} from "../../../common/Helper/AxiosHelper";

export default {
    name  : "TextEditor",
    mixins: [InputMixin],
    data() {
        return {
            fieldValue         : '',
            updatingFromOutside: false
        };
    },
    mounted() {
        this.fieldValue = this.value
        setTimeout(() => this.initComponent(), 300)
    },
    watch: {
        value: function (value) {
            if (value !== this.fieldValue || typeof value === "undefined") {
                this.updatingFromOutside = true
                this.fieldValue          = value || '';
                this.setInitValue(value || '')
                this.updatingFromOutside = false
            }
        },
    },
    // computed: {
    //     editorValue() {
    //         return this.value;
    //     }
    // },
    methods: {
        initComponent() {
            const config = {
                placeholder  : this.data.placeholder,
                dialogsInBody: true,
                height       : this.data.height,
                callbacks    : {
                    onImageUpload: this.uploadImage,
                    onChange     : (contents) => {
                        if (!this.updatingFromOutside) {
                            this.input(contents);
                        }
                    }
                }
            };
            if (Object.keys(this.data.textEditorHints).length) {
                config.hint = this.data.textEditorHints
            }
            if (this.data.minimal === true) {
                config.toolbar = [
                    ['style', ['bold', 'italic', 'underline']],
                    ['fontsize', ['fontsize', 'height', 'color']],
                    ['para', ['ul', 'ol']],
                    ['insert', ['picture', 'link', 'video']]
                ]
            }

            $("#" + this.inputFieldId).summernote(config);
        },
        uploadImage(files) {
            const data = new FormData();

            data.append('image', files[0]);

            axiosPost(`${TENANT_BASE_URL}api/upload-image`, data).then(({data}) => {
                if (data.url) {
                    $("#" + this.inputFieldId).summernote('insertImage', data.url);
                }
            })
        },
        setInitValue(initialValue) {
            $("#" + this.inputFieldId).summernote('code', initialValue);
        },
        input(contents) {
            this.fieldValue = contents;
            this.$emit('input', contents);
        }
    }
}
</script>
